<template>
  <div class="animated fadeIn">
   
    <b-row> 
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Master AWB</strong> 

          </div>


          <b-row>
           <b-col md="12" >
    
           <div v-if="hub_id=='365'">
            <ul class="nav nav-tabs nav-justified">
             
             <li class="nav-item" >
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Created</a>
              </li>

         
              <li class="nav-item" >
                <a @click="activeTab = 2"  class="nav-link" :class="{'active' : isActiveTab(2)}" >Dispatch</a>
              </li>
              
            </ul>
          </div>
           <div v-if="hub_id!='365'">
            <ul class="nav nav-tabs nav-justified">
             
             <!-- <li class="nav-item" >
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Created</a>
              </li> -->

              <li class="nav-item" >
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Upcoming</a>
              </li>

              <li class="nav-item" >
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Received</a>
              </li>
              <li class="nav-item" >
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Dispatch</a>
              </li>
              
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" v-if="hub_id=='365'">
       
            <div class="tab-panel" v-if="isActiveTab(1)">
            <MasterAwbcreated style="width:70%;"></MasterAwbcreated>
            </div>
         

            <div class="tab-panel" v-if="isActiveTab(2)">
            <MasterAwbdispatch style="width:70%;" ></MasterAwbdispatch>
            </div>
          </b-col>
          <b-col md="12" v-if="hub_id!='365'">
       
            <div class="tab-panel" v-if="isActiveTab(1)">
            <MasterAwbupcoming style="width:70%;"></MasterAwbupcoming>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <MasterAwbreceived style="width:70%;"></MasterAwbreceived>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <MasterAwbdispatch style="width:70%;" ></MasterAwbdispatch>
            </div>
          </b-col>

          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import MasterAwbcreated from './MasterAwbcreated.vue'
import MasterAwbupcoming from './MasterAwbupcoming.vue'
import MasterAwbreceived from './MasterAwbreceived.vue'
import MasterAwbdispatch from './MasterAwbdispatch.vue'

export default {
  data: function() {
    return {
      hub_id:'',
      activeTab: 1,
      MasterAwbcreated,
      MasterAwbupcoming,
      MasterAwbreceived,
      MasterAwbdispatch,
      name: 'MasterAWBForKSA'
     
    };
  },
  components: {
   MasterAwbcreated,
   MasterAwbupcoming,
   MasterAwbreceived,
   MasterAwbdispatch

  },
 created: function() {
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.hub_id = userInfo.pickuplocationmasterid;
    this.isActiveTab(1);
  },
 
  methods: {
    isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }




  

};
</script>
